import(/* webpackMode: "eager" */ "/vercel/path0/app/ai-assistant/page.tsx");
